import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, FlatButton, CircularProgress } from 'material-ui';
import { updateProps } from '../../../stores/newsfeed/postPage/actions';
import R from 'ramda';
import SignUp from './signup';
import SinglePost from '../mainFeed/postTypes/singlePostContainer';
import InternalExtraActions from './internalExtraAction';

const PublicPost = (props, context) => {
  const {
    publicPostReducer,
    companyName,
    updateProp,
    displayType,
    postId,
  } = props;

  const isNilOrEmpty = R.either(R.isEmpty, R.isNil);
  const isTCUser = !isNilOrEmpty(companyName);
  const pluralPostCompanyName = R.equals('s', R.last(publicPostReducer.companyName)) ? `${publicPostReducer.companyName}'` : `${publicPostReducer.companyName}'s`;

  return (
    <div style={{ top: '75px', position: 'relative', paddingBottom: '100px', width: '70%', margin: 'auto' }}>
      {
        publicPostReducer.gettingPost ?
          <div style={{ textAlign: 'center', display: 'block' }}>
            <CircularProgress size={100} style={{ marginTop: '100px' }} />
          </div> :
          <div className="Grid">
            <div className="Grid-cell Grid--center">
              <div style={{ width: '70%', margin: '10px auto', color: 'rgba(0, 0, 0, 0.54)' }}>
                <SinglePost loaded body={publicPostReducer} displayType={displayType} postId={postId} />
              </div>
              {
                isTCUser ?
                  <InternalExtraActions postCompName={pluralPostCompanyName} goToPostCompProfile={() => context.router.push(`/company/${publicPostReducer.companyId}`)} />
                  : <SignUp postCompName={pluralPostCompanyName} />
              }
            </div>
          </div>
      }
      <Dialog
        title={`Want to view ${pluralPostCompanyName} profile?`}
        actions={[
          <FlatButton
            label="Close"
            primary
            onTouchTap={() => updateProp({ showPublicSignUpDialog: false })}
          />,
        ]}
        modal
        open={publicPostReducer.showPublicSignUpDialog}
      >
        In order to view their profile, please
        <a
          onTouchTap={() => updateProp({ showPublicSignUpDialog: false })}
          href={`${window.location.protocol}//${window.location.host}/signup`}
          rel="external"
          style={{ backgroundColor: 'rgb(0, 188, 212)', borderRadius: '2px', color: 'white', padding: '7px', marginLeft: '5px', lineHeight: '36px', fontWeight: '400', fontSize: '14px' }}
        >SIGN IN / SIGN UP</a>
      </Dialog>
    </div>
  );
};

PublicPost.propTypes = {
  publicPostReducer: PropTypes.object,
  companyName: PropTypes.string,
  displayType: PropTypes.string,
  updateProp: PropTypes.func,
  postId: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
});

const mapStateToProps = ({ publicPost, user }) => ({
  publicPostReducer: publicPost.toJS(),
  companyName: user ? user.getIn(['company', 'companyName']) : undefined,
});

PublicPost.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicPost);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/postPage/post.jsx